import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import {
  starSolidIcon,
  settingIcon,
  listIcon,
  photoIcon,
  checkIcon,
  mIcon,
} from "./Icons";

export default function NavMenu(props) {
  const {
    openNav,
    setOpenNav,
    store,
    setViewStore,
    viewStore,
    setSettingDialog,
    setOpenImageDialog,
    common,
    setCommon,
  } = props;

  const [active, setActive] = useState(false);

  const handleSetting = () => {
    setSettingDialog(true);
    setOpenNav(false);
  };

  const handleStore = () => {
    setViewStore(true);
    setOpenNav(false);
  };
  const handleMain = () => {
    setViewStore(false);
    setOpenNav(false);
  };
  const handleImage = () => {
    setOpenImageDialog(true);
    setOpenNav(false);
  };
  const handleMatlib = () => {
    window.open("https://designer.matlib.co/lib");
  };

  useEffect(() => {
    if (!active) {
      const timeout = setTimeout(() => {
        setOpenNav(false);
      }, 3000);
      return () => clearTimeout(timeout);
    }
    // eslint-disable-next-line
  }, [active]);

  return (
    <motion.div
      initial={false}
      animate={{ height: openNav ? "auto" : "0px" }}
      transition={{ duration: 0.2, delay: 0.3 }}
      className="nav-menu"
      onMouseEnter={() => setActive(true)}
      onMouseLeave={() => setActive(false)}
    >
      <div className="nav-menu-body">
        {viewStore ? (
          <div className="nav-menu-item" onClick={handleMain}>
            <span className="nav-menu-icon">{listIcon}</span>
            <h5>View all CSI's</h5>
          </div>
        ) : (
          <div className="nav-menu-item" onClick={handleStore}>
            <span className="nav-menu-icon">{starSolidIcon}</span>
            <h5>View {store.length} Stored CSI's</h5>
          </div>
        )}
        {common ? (
          <div className="nav-menu-item" onClick={() => setCommon(false)}>
            <span className="nav-menu-icon">{listIcon}</span>
            <h5>View all CSI's</h5>
          </div>
        ) : (
          <div className="nav-menu-item" onClick={() => setCommon(true)}>
            <span className="nav-menu-icon">{checkIcon}</span>
            <h5>common crust</h5>
          </div>
        )}
        <div className="nav-menu-item" onClick={handleSetting}>
          <span className="nav-menu-icon">{settingIcon}</span>
          <h5>Change Settings</h5>
        </div>
        <div className="nav-menu-item" onClick={handleImage}>
          <span className="nav-menu-icon">{photoIcon}</span>
          <h5>Colors By Image</h5>
        </div>
        <div className="nav-menu-item" onClick={handleMatlib}>
          <span className="nav-menu-icon">{mIcon}</span>
          <h5>Digital Library</h5>
        </div>
      </div>
    </motion.div>
  );
}
